import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField
} from 'react-admin';

// own ui
import CustomFilterText from '../../ui/custom-filter-text';
import LinkField from '../../ui/link-field';
import ReportedProblemCheckPointExporter from '../../exporter/reported-problem-check-point-exporter';

const ReportedProblemCheckPointList = (props) => (
    <List
      title="Problemas em Pontos de Check-In" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterText /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ ReportedProblemCheckPointExporter } >
        <Datagrid
          rowClick="show">
          <TextField source="id" sortable={true} />
          <TextField source="check_point_name" label="Ponto de Check-In" sortable={false} />
          <TextField source="contact_name" label="Nome" sortable={false} />
          <TextField source="contact_email" label="E-mail" sortable={false} />
          <LinkField source="image.url" text="Abrir" label="Imagem" sortable={false}/>
          <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} />
        </Datagrid>
    </List>
);

export default ReportedProblemCheckPointList;
